import PropTypes from 'prop-types';

const defaultProps = {};

const propTypes = {
  city: PropTypes.string,
  coaching: PropTypes.bool,
  languages: PropTypes.array,
  privateTraining: PropTypes.bool,
  trainings: PropTypes.arrayOf(PropTypes.object),
};

export {
  defaultProps as trainerInfoDefaultProps,
  propTypes as trainerInfoPropTypes,
};
